module.exports = __webpack_public_path__ + "1801996a1845aff0ea25a894d9485eaa.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/beady-6.png
// module id = 2019
// module chunks = 0